import { styled } from "@linaria/react"

import { TokenInfo } from "../../ao/token"
import { NumberFont } from "../../theme"
import { formatNumberAuto, formatTicker, parseBigIntAsNumber } from "../../utils/format"
import { Stack } from "../Stack"

type RemoveOrderDetailsProps = {
  expectedTokenA: bigint
  expectedTokenB: bigint
  tokenA?: TokenInfo
  tokenB?: TokenInfo
  lpAmountNormalized: bigint
}

export function RemoveOrderDetails(props: RemoveOrderDetailsProps) {
  const { expectedTokenA, expectedTokenB, tokenA, tokenB, lpAmountNormalized } = props

  if (lpAmountNormalized === 0n) return

  return (
    <>
      <DetailsRow>
        <span>Expected {formatTicker(tokenA?.ticker, true)}</span>
        <span>{formatNumberAuto(parseBigIntAsNumber(expectedTokenA, tokenA?.denomination))} </span>
      </DetailsRow>
      <DetailsRow>
        <span>Expected {formatTicker(tokenB?.ticker, true)}</span>
        <span>{formatNumberAuto(parseBigIntAsNumber(expectedTokenB, tokenB?.denomination))} </span>
      </DetailsRow>
      <DetailsRow>
        <span>Network cost</span>
        <span>0 AO</span>
      </DetailsRow>
    </>
  )
}

const DetailsRow = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;

  & > span:first-of-type {
    white-space: nowrap;
    color: var(--mui-palette-secondary-main);
  }

  & > span:last-of-type {
    white-space: nowrap;
    font-family: ${NumberFont};
  }
`
